var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933008,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint0_linear_706_71243)",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.933008,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint1_linear_706_71243)",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5326,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint2_linear_706_71243)",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5326,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint3_linear_706_71243)",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4359 46.1646V41.9996C29.4356 41.8597 29.4078 41.7213 29.354 41.5921C29.3002 41.463 29.2215 41.3457 29.1224 41.247C29.0232 41.1482 28.9056 41.07 28.7763 41.0168C28.6469 40.9635 28.5083 40.9362 28.3684 40.9365H26.2071C25.9248 40.9367 25.654 41.0486 25.454 41.2478C25.254 41.447 25.1409 41.7173 25.1396 41.9996V46.1646C25.7171 46.1645 29.4359 46.1646 29.4359 46.1646Z",
    fill: "#009DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9694 34.4873C31.6875 34.4876 31.4173 34.5997 31.218 34.799C31.0187 34.9983 30.9065 35.2686 30.9062 35.5504V46.1642C31.9934 46.1649 34.1109 46.1636 35.1981 46.1642V35.5504C35.1978 35.2686 35.0857 34.9983 34.8864 34.799C34.6871 34.5997 34.4169 34.4876 34.135 34.4873H31.9694Z",
    fill: "#009DDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7311 37.5586C37.4488 37.5599 37.1785 37.6729 36.9792 37.873C36.78 38.073 36.6681 38.3438 36.668 38.6261V46.1642C37.7552 46.1648 39.8726 46.1638 40.9598 46.1642V38.6261C40.9597 38.3438 40.8478 38.073 40.6486 37.873C40.4494 37.6729 40.179 37.5599 39.8967 37.5586H37.7311Z",
    fill: "#009DDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4972 29.9551C43.3573 29.9548 43.2187 29.982 43.0893 30.0353C42.96 30.0886 42.8424 30.1668 42.7432 30.2655C42.6441 30.3642 42.5654 30.4815 42.5116 30.6107C42.4578 30.7398 42.43 30.8783 42.4297 31.0182V46.1645C43.5174 46.1655 45.6382 46.1637 46.7259 46.1645V31.0182C46.7246 30.7359 46.6116 30.4656 46.4116 30.2663C46.2115 30.0671 45.9408 29.9552 45.6584 29.9551H43.4972Z",
    fill: "#009DDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7452 47.0391H24.1202C24.0054 47.0408 23.8958 47.0877 23.8152 47.1696C23.7346 47.2514 23.6894 47.3617 23.6895 47.4766C23.6895 47.5914 23.7346 47.7017 23.8152 47.7836C23.8958 47.8654 24.0054 47.9123 24.1202 47.9141H47.7452C47.8601 47.9123 47.9696 47.8654 48.0502 47.7836C48.1308 47.7017 48.176 47.5914 48.176 47.4766C48.176 47.3617 48.1308 47.2514 48.0502 47.1696C47.9696 47.0877 47.8601 47.0408 47.7452 47.0391Z",
    fill: "#009DDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2347 34.6712C27.5164 34.6688 27.7929 34.5948 28.0381 34.456C28.2832 34.3172 28.489 34.1183 28.6361 33.8781C28.7831 33.6378 28.8666 33.364 28.8786 33.0826C28.8906 32.8011 28.8308 32.5213 28.7047 32.2693L32.1172 29.1631C32.4494 29.3714 32.8447 29.4551 33.2329 29.3994C33.621 29.3437 33.9768 29.1521 34.237 28.8588L37.1394 30.2817C37.0908 30.5391 37.1041 30.8044 37.1783 31.0557C37.2525 31.307 37.3855 31.537 37.5663 31.7267C37.747 31.9164 37.9703 32.0603 38.2177 32.1466C38.4651 32.2329 38.7295 32.259 38.989 32.2228C39.2485 32.1867 39.4956 32.0892 39.71 31.9386C39.9244 31.788 40.0998 31.5885 40.2218 31.3566C40.3438 31.1247 40.4088 30.8671 40.4115 30.6051C40.4142 30.3431 40.3545 30.0842 40.2372 29.8499L43.7329 26.7262C44.0688 26.9437 44.4723 27.032 44.8684 26.9746C45.2645 26.9172 45.6263 26.718 45.8867 26.414C46.1471 26.1101 46.2883 25.722 46.2843 25.3218C46.2802 24.9215 46.131 24.5364 45.8645 24.2378C45.598 23.9392 45.2322 23.7475 44.835 23.6982C44.4378 23.6488 44.0362 23.7453 43.7048 23.9696C43.3733 24.1939 43.1345 24.5309 43.0327 24.918C42.9308 25.305 42.9729 25.7159 43.151 26.0743L39.651 29.2024C39.3199 28.9893 38.9234 28.9018 38.5333 28.9557C38.1432 29.0095 37.7853 29.2013 37.5243 29.4961L34.6199 28.0723C34.6688 27.8142 34.6554 27.5481 34.5808 27.2962C34.5062 27.0442 34.3726 26.8137 34.191 26.6238C34.0094 26.4339 33.7852 26.2901 33.5368 26.2042C33.2885 26.1184 33.0233 26.0931 32.7632 26.1304C32.5031 26.1676 32.2557 26.2664 32.0415 26.4185C31.8272 26.5706 31.6524 26.7717 31.5315 27.0049C31.4105 27.2382 31.347 27.4969 31.3462 27.7597C31.3453 28.0224 31.4072 28.2815 31.5266 28.5156L28.1141 31.6218C27.8974 31.4852 27.6519 31.4008 27.397 31.3754C27.1421 31.35 26.8847 31.3842 26.6453 31.4753C26.4059 31.5665 26.1909 31.712 26.0175 31.9005C25.844 32.0891 25.7167 32.3153 25.6457 32.5615C25.5748 32.8076 25.562 33.0669 25.6085 33.3188C25.6549 33.5708 25.7593 33.8085 25.9135 34.0131C26.0676 34.2177 26.2672 34.3837 26.4965 34.4979C26.7258 34.6121 26.9786 34.6715 27.2347 34.6712Z",
    fill: "#009DDD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_71243",
    x1: 6.19398,
    y1: 75.3075,
    x2: 74.7891,
    y2: -4.57542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_71243",
    x1: 71.3159,
    y1: -8.91687,
    x2: 6.19398,
    y2: 71.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_71243",
    x1: 4.27133,
    y1: 12.7353,
    x2: 61.7229,
    y2: 61.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_71243",
    x1: 72.2068,
    y1: 73.5417,
    x2: 11.8197,
    y2: 30.7675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.029eeff1f5ea1ff257d7b65ee5eab575.svg";
export { ForwardRef as ReactComponent };